import { render, staticRenderFns } from "./TopBarMenu.vue?vue&type=template&id=4b296f0d&scoped=true"
import script from "./TopBarMenu.vue?vue&type=script&lang=js"
export * from "./TopBarMenu.vue?vue&type=script&lang=js"
import style0 from "./TopBarMenu.vue?vue&type=style&index=0&id=4b296f0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b296f0d",
  null
  
)

export default component.exports